module.exports = __webpack_public_path__ + "static/media/kim.3f8c67ba.jpg";